module.exports = __webpack_public_path__ + "assets/img/shopping_cart.bc2dfe16.svg";